import { updateMediaItemF } from '../../../backend/mediaItems/updateData'
import { createFragment } from '../../../backend/uploadType2/createFragment'
import { deleteFragment } from '../../../backend/uploadType2/deleteFragment'
import { updateUploadType2 } from '../../../backend/uploadType2/updateData'
import { globalOnDemandVars } from '../../../helper/context'
import * as shortId from 'shortid'
import { getProperties } from '../../../helper/functions'
// import { InsertItemBase } from '../../addon/addons/parts/type1Class'

class InsertItemBase {
  constructor (type, title, content) {
    this.type = type
    this.title = title
    this.content = content
    this.globalId = null
  }

  setTitle (newTitle) {
    if (this.globalId) {
      updateMediaItemF(this.globalId, {
        title: newTitle
      }).then(() => {
        this.title = newTitle
      })
    } else {
      this.title = newTitle
    }
  }

  setContent (newContent) {
    this.content = newContent
  }

  setGlobalId (id) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'media setGlobalId',
        value: {
          globalId: id,
          this: this
        }
        // , important: true
      })
    }
    this.globalId = id
  }
}

export class Type2Or3Item extends InsertItemBase {
  constructor ({ id, type, title, content, fragmentList, switchForMultipleCard, inWaitingList, timeStamp, hideAll, isType3 }) {
    const id2 = id || shortId.generate()
    const title2 = title || (type + '-' + id2)

    super(type, title2, content)

    this.id = id || id2
    // this.title = title2
    // this.type = type
    // this.content = content
    this.fragmentList = fragmentList || []
    if (typeof hideAll !== 'undefined') {
      this.hideAll = hideAll
    } else {
      this.hideAll = true
    }
    if (typeof switchForMultipleCard !== 'undefined') {
      this.switchForMultipleCard = switchForMultipleCard
    } else {
      this.switchForMultipleCard = true
    }
    if (typeof inWaitingList !== 'undefined') {
      this.inWaitingList = inWaitingList
    } else {
      this.inWaitingList = true
    }
    this.timeStamp = timeStamp || Date.now()
    // -----------------------------------------------------------------------------------------------------------

    this.ThumbNailForceUpdateObject = {}
    // -----------------------------------------------------------------------------------------------------------

    this.isType3 = isType3 || false
  }

  // -----------------------------------------------------------------------------------------------------------

  setContent (newContent) {
    if (this.isType3) {
      this.content = newContent
    } else {
      let newContent2 = newContent
      if (typeof newContent !== 'string') {
        newContent2 = JSON.stringify(newContent)
      }

      this.content = newContent2
      updateUploadType2(this.id, {
        content: newContent2
      })
    }
    this.thumbnailForceUpdate()
  }

  setThumbNailForceUpdate (id, f) {
    this.ThumbNailForceUpdateObject[id] = f
  }

  deleteThumbNailForceUpdate (id) {
    delete this.ThumbNailForceUpdateObject[id]
  }

  thumbnailForceUpdate () {
    for (let i of Object.getOwnPropertyNames(this.ThumbNailForceUpdateObject)) {
      this.ThumbNailForceUpdateObject[i]()
    }
  }

  // -----------------------------------------------------------------------------------------------------------

  setFragmentListWithoutDB (newFragmentList) {
    this.fragmentList = newFragmentList
  }

  setInWaitingList (newValue) {
    this.inWaitingList = newValue
    if (!globalOnDemandVars.isPixelMode()) {
      updateUploadType2(this.id, {
        inWaitingList: newValue
      })
    }
  }

  setHideAll (newValue) {
    this.hideAll = newValue
    if (!globalOnDemandVars.isPixelMode()) {
      updateUploadType2(this.id, {
        hideAll: newValue
      })
    }
  }

  setSwitchForMultipleCard (newValue) {
    this.switchForMultipleCard = newValue
    if (!globalOnDemandVars.isPixelMode()) {
      updateUploadType2(this.id, {
        switchForMultipleCard: newValue
      })
    }
  }

  createFragment (newFragment) {
    const originalFragmentCount = this.fragmentList.length

    this.fragmentList.unshift(newFragment)
    if (!globalOnDemandVars.isPixelMode()) {
      const properties = getProperties(newFragment)
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'uploadType2 / createFragment',
          value: {
            fragmentInput: properties
          }
          // , important: true
        })
      }
      createFragment(this.id, newFragment.id, properties)
    }

    if (originalFragmentCount === 0) {
      this.thumbnailForceUpdate()
    }
  }

  deleteFragment (fragmentId) {
    const index = this.fragmentList.findIndex((fragment) => (fragment.id === fragmentId))
    this.fragmentList.splice(index, 1)
    if (!globalOnDemandVars.isPixelMode()) {
      deleteFragment(this.id, fragmentId)
    }

    if (this.fragmentList.length === 0) {
      this.thumbnailForceUpdate()
    }
  }

  updateFragment (fragmentId, update) {
    this.fragmentList.find((fragment) => (fragment.id === fragmentId)).update(update)
  }

  clear () {
    this.fragmentList = []
    this.switchForMultipleCard = true
    this.hideAll = true
    this.inWaitingList = true
  }

  setForPixelMode ({ type, title, content, fragmentList, switchForMultipleCard, inWaitingList }) {
    this.type = type
    this.title = title || ''
    this.content = content
    this.fragmentList = fragmentList || []
    this.switchForMultipleCard = switchForMultipleCard
    this.inWaitingList = inWaitingList
  }
}
